import * as React from "react";

import { ElementUpdateLoadingIndicator } from "@v1/components/header/ElementUpdateLoadingIndicator";
import PageControlButtons from "@v1/components/header/PageControlButtons";

const RightBarHeader = () => {
  return (
    <div className="shadow-xs border-0.5 border-border absolute right-2 top-2 flex items-center gap-2 rounded-xl bg-white p-3">
      <ElementUpdateLoadingIndicator />
      <PageControlButtons />
    </div>
  );
};

export default RightBarHeader;
